// Purpose: Controller to compare two HTML elements using htmldiff-js. This is commonly used to compare text with a previous version.
//
// Usage: Add `data-controller="htmldiff-compare"` to the element you want to compare. Add `data-diff-key` to the element with a unique
// key to match the other element. Add `data-diff-side` to the element with the value `current` or `previous` to indicate which side it is
// on. Add the other element with the same `data-diff-key` and the opposite `data-diff-side` value.

import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element[this.identifier] = this;
    this.render();
  }

  initializeScriptTag(id) {
    if (!document.getElementById(id)) {
      let js = document.createElement('script');
      js.id = id;
      js.src = document.querySelector('meta[name=' + id + ']').getAttribute('value');
      document.head.appendChild(js);
    }
  }

  async render() {
    if (typeof window.HtmlDiff === 'undefined') {
      this.initializeScriptTag('htmldiff-js');
    }
    while (typeof window.HtmlDiff === 'undefined') {
      await new Promise(r => setTimeout(r, 100));
    }
    this.renderDiff();
  }

  key() {
    return this.element.dataset.diffKey;
  }

  side() {
    return this.element.dataset.diffSide;
  }

  otherSide() {
    return this.side() === 'current' ? 'previous' : 'current';
  }

  otherElement() {
    return document.querySelector(`[data-diff-key="${this.key()}"][data-diff-side="${this.otherSide()}"]`);
  }

  renderDiff() {
    let other = this.otherElement();
    if (!other) {
      return;
    }

    let v1 = this.side() === 'current' ? this.element : other;
    let v2 = this.side() === 'current' ? other : this.element;

    let diff = window.HtmlDiff.execute(v2.innerHTML, v1.innerHTML);
    diff = diff.replace(/class=["']diff(mod|ins|del)["']/g, 'class="diffmod"');

    v1.innerHTML = diff.replace(/<del(.*?)<\/del>/gs, '').replace(/<\/ins>\s*<ins class="diffmod">/g, ' ');
    v2.innerHTML = diff.replace(/<ins(.*?)<\/ins>/gs, '').replace(/<\/del>\s*<del class="diffmod">/g, ' ');
  }
}
